<template>
    <div :class="{
            'map-modal': true,
            '_price-modal': encType,
        }"
        v-if="markerData"
    >
        <div class="map-modal__header">
            <span @click="closeModal">
                {{ "map.close" | trans }}
                <inline-svg
                    name="map/map-delete"
                    classes="map-delete"
                ></inline-svg
            ></span>
        </div>
        <toll-modal
            v-if="type === 'toll'"
            :marker-data="markerData"
        ></toll-modal>
        <camera-modal
            v-if="type === 'cameras'"
            :title="markerData.name"
            :camera-links="markerData.camera_links"
            :image="markerData.image ? markerData.image : markerData.url"
        ></camera-modal>
        <object-modal
            v-if="typeInObjects"
            :title="objectTitle"
            :content="objectContent"
        ></object-modal>
        <pricelist-modal
            v-if="encType"
            :title="markerData.name"
            :content="markerData.content"
            :prices="markerData.prices"
            :toll-id="markerData.id"
            :work-time="markerData.work_time ? markerData.work_time : ''"
            :toll-track="markerData.toll_track ? markerData.toll_track : ''"
            :phone="markerData.phone ? markerData.phone : ''"
            :enc_fill="markerData.enc_fill"
        ></pricelist-modal>
        <rest-area-modal
            v-if="typeInRestArea"
            :title="markerData.name"
            :gallery="markerData.gallery"
            :marker-data="markerData"
        ></rest-area-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import inlineSvg from "./inlineSvg.js";
import TollModal from "./modals/TollModal.vue";
import CameraModal from "./modals/CameraModal.vue";
import ObjectModal from "./modals/ObjectModal.vue";
import PricelistModal from "./modals/PricelistModal.vue";
import RestAreaModal from "./modals/RestAreaModal.vue";

import Vue from "vue";

export default {
    name: "MapModal",
    components: {
        inlineSvg,
        TollModal,
        CameraModal,
        ObjectModal,
        PricelistModal,
        RestAreaModal
    },
    data() {
        return {
            type: null,
            markerData: null
        };
    },
    methods: {
        closeModal() {
            this.$store.commit("setModal", null);
        },

        setModalData(modal) {
            if (modal && modal.data) {
                this.type = modal.type;
                modal.data.content = modal.data.content
                    ? modal.data.content
                    : this.trans.get("map.toll_error_message");
                Vue.set(this, "markerData", modal.data);
            } else {
                Vue.set(this, "markerData", null);
            }
        }
    },

    mounted() {
        this.setModalData(this.modal);
    },

    computed: {
        ...mapGetters(["modal", "objects", "restAreas", "gasStationTypes"]),

        typeInObjects() {
            if (this.type) {
                if (this.objects.find(object => object === this.type)) {
                    return true;
                }
            }
            return false;
        },

        typeInRestArea() {
            if (this.type) {
                if (
                    this.restAreas.find(restArea => restArea === this.type) ||
                    this.type === "restAreas" ||
                    this.gasStationTypes.find(
                        gasStation => gasStation === this.type
                    ) ||
                    this.type === "searchResult"
                ) {
                    return true;
                }
            }
            return false;
        },

        encType() {
            return (
                this.type === "enc_regular" ||
                this.type === "enc_sale" ||
                this.type === "enc_fill" ||
                this.type === "tollPlaces"
            );
        },

        objectTranslation() {
            if (this.typeInObjects) {
                if (this.markerData.translation) {
                    let activeTranslation = this.markerData.translation.find(
                        trans => trans.locale === window.default_locale
                    );
                    return activeTranslation;
                } else if (this.markerData.translations) {
                    let activeTranslation = this.markerData.translations.find(
                        trans => trans.locale === window.default_locale
                    );
                    return activeTranslation;
                }
                return null;
            }
            return null;
        },

        objectTitle() {
            if (this.objectTranslation && this.objectTranslation.title) {
                return this.objectTranslation.title;
            }

            return "";
        },
        objectContent() {
            if (this.objectTranslation && this.objectTranslation.content) {
                return this.objectTranslation.content;
            }
            return this.trans.get("map.no_description");
        }
    },

    watch: {
        modal(newValue) {
            this.setModalData(newValue);
        }
    }
};
</script>
